import * as React from 'react';
import { DropdownItem } from '../Dropdown';
import { OverflowMenuContext } from './OverflowMenuContext';
export var OverflowMenuDropdownItem = function OverflowMenuDropdownItem(_ref) {
  var children = _ref.children,
      _ref$isShared = _ref.isShared,
      isShared = _ref$isShared === void 0 ? false : _ref$isShared;
  return React.createElement(OverflowMenuContext.Consumer, null, function (value) {
    return (!isShared || value.isBelowBreakpoint) && React.createElement(DropdownItem, {
      component: "button"
    }, " ", children, " ");
  });
};